<div class="go-back-instructions">
    <app-go-back (actionClick)="returnToInstructions()" text="Volver a instrucciones"></app-go-back>
</div>
